import { useMemo } from "react";

import InteractionService from "@/service/Interaction";
import { Interaction } from "@/service/Model";
import { themeRegistry } from "@/styles";
import { ThemeName } from "@/styles/Theme";

export const useTheme = (themeName: ThemeName, interaction: Interaction) => {
  return useMemo(() => {
    const currentTheme = themeRegistry[themeName] || themeRegistry.default;
    if (!InteractionService.hasBackgroundImage(interaction)) {
      currentTheme.globals.minInteractionHeight = "0";
    }
    // Add brand name to theme for easy access in components
    return currentTheme;
  }, [themeName, interaction]);
};
